const STATUS_ICONS = {
  draft: "fa-pencil",
  awaiting_configuration: "fa-pencil",
  scheduled: "fa-calendar",
  live: "fa-check",
  completed: "fa-check",
  cancel_hold: "fa-circle",
  canceled: "fa-circle",
  pending_approval: "fa-clock-o",
  pending_compliance_approval: "fa-clock-o",
  pending_network_audit: "fa-clock-o",
  pending_network_start: "fa-clock-o",
  pending_submission: "fa-clock-o",
  pending_creative_submission: "fa-clock-o",
  pending_extend: "fa-clock-o",
  pending_recurrence: "fa-clock-o",
  create_failed: "fa-exclamation-circle",
  payment_failed: "fa-exclamation-circle",
  compliance_rejected: "fa-exclamation-circle",
  network_rejected: "fa-exclamation-circle",
  submission_failed: "fa-exclamation-circle"
};

const getCampaignStatusIcon = (status, statusCategory) => {
  if (statusCategory === "action-required") return "fa-exclamation-circle";
  if (STATUS_ICONS[status]) return STATUS_ICONS[status];
  return "fa-circle";
};

export { STATUS_ICONS };

export default getCampaignStatusIcon;
